/**
 * Generated by orval 🍺
 * Do not edit manually.
 * TrainLoop Platform V2 API
 * Model evaluation workbench API
 * OpenAPI spec version: 0.0.0
 */
import { useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { HTTPValidationError, ProxyModelListItem } from "../model";

import { orvalFetch } from "../../client.ts";
import type { ErrorType } from "../../client.ts";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type listProxyModelsApiProxyModelsGetResponse200 = {
  data: ProxyModelListItem[];
  status: 200;
};

export type listProxyModelsApiProxyModelsGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listProxyModelsApiProxyModelsGetResponseSuccess =
  listProxyModelsApiProxyModelsGetResponse200 & {
    headers: Headers;
  };
export type listProxyModelsApiProxyModelsGetResponseError =
  listProxyModelsApiProxyModelsGetResponse422 & {
    headers: Headers;
  };

export type listProxyModelsApiProxyModelsGetResponse =
  | listProxyModelsApiProxyModelsGetResponseSuccess
  | listProxyModelsApiProxyModelsGetResponseError;

export const getListProxyModelsApiProxyModelsGetUrl = () => {
  return `/api/proxy-models`;
};

/**
 * List active catalog entries for the create-model dropdown.
 *
 * Auth-gated but not team-scoped — the catalog is the same for every
 * team (per the design: engineering-managed list of base models all
 * teams have access to).
 * @summary List Proxy Models
 */
export const listProxyModelsApiProxyModelsGet = async (
  options?: Parameters<typeof orvalFetch>[1],
): Promise<listProxyModelsApiProxyModelsGetResponse> => {
  return orvalFetch<listProxyModelsApiProxyModelsGetResponse>(
    getListProxyModelsApiProxyModelsGetUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListProxyModelsApiProxyModelsGetQueryKey = () => {
  return [`/api/proxy-models`] as const;
};

export const getListProxyModelsApiProxyModelsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listProxyModelsApiProxyModelsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listProxyModelsApiProxyModelsGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof orvalFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListProxyModelsApiProxyModelsGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listProxyModelsApiProxyModelsGet>>
  > = ({ signal }) =>
    listProxyModelsApiProxyModelsGet({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listProxyModelsApiProxyModelsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListProxyModelsApiProxyModelsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listProxyModelsApiProxyModelsGet>>
>;
export type ListProxyModelsApiProxyModelsGetQueryError =
  ErrorType<HTTPValidationError>;

export function useListProxyModelsApiProxyModelsGet<
  TData = Awaited<ReturnType<typeof listProxyModelsApiProxyModelsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listProxyModelsApiProxyModelsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProxyModelsApiProxyModelsGet>>,
          TError,
          Awaited<ReturnType<typeof listProxyModelsApiProxyModelsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListProxyModelsApiProxyModelsGet<
  TData = Awaited<ReturnType<typeof listProxyModelsApiProxyModelsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listProxyModelsApiProxyModelsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProxyModelsApiProxyModelsGet>>,
          TError,
          Awaited<ReturnType<typeof listProxyModelsApiProxyModelsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListProxyModelsApiProxyModelsGet<
  TData = Awaited<ReturnType<typeof listProxyModelsApiProxyModelsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listProxyModelsApiProxyModelsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Proxy Models
 */

export function useListProxyModelsApiProxyModelsGet<
  TData = Awaited<ReturnType<typeof listProxyModelsApiProxyModelsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listProxyModelsApiProxyModelsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListProxyModelsApiProxyModelsGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}
